// extracted by mini-css-extract-plugin
module.exports = {"compareChartColour1":"#92278f","compareChartColour2":"#f03093","compareChartColour3":"#bdc63f","compareChartColour4":"#fcaf17","compareChartColour5":"#00b2e3"};